import firebase from "firebase";

// Initialize Firebase
const config = {
  apiKey: "AIzaSyAUOdfxW-g5weeFeG88B4ZY8PLaxQH6eEs",
  authDomain: "hablemosdepsiquiatria-lundbeck.firebaseapp.com",
  projectId: "hablemosdepsiquiatria-lundbeck",
  storageBucket: "hablemosdepsiquiatria-lundbeck.appspot.com",
  messagingSenderId: "954120083384",
  appId: "1:954120083384:web:0e6f4b5ccda2f1a46de14d",
  measurementId: "G-7ZXV30SV60"
};
firebase.initializeApp(config);
firebase.auth().languageCode = 'es'
const auth = firebase.auth();
const functions = firebase.functions();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();
const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();

const database = firebase.firestore();

export {
  database,
  auth,
  functions,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider
};
